export const SIZES = {
  sm: "small",
  default: "default",
  lg: "large",
};
